module.exports = __webpack_public_path__ + "img/cover_load.a2123781.svg";